import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../static/css/AdminLogin.css";

function AdminLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [ischecked, setIsChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handlesubmit = async (e) => {
    e.preventDefault();

    // LOCAL DEVELOPMENT MODE - Remove this in production
    if (email === "admin@local.dev" && password === "admin123") {
      console.log("Login successful (LOCAL DEV MODE)");
      navigate("/admincontrol");
      return;
    }

    const loginData = { emailid: email, password };

    try {
      const response = await fetch("http://backend.ibcupdates.com//users/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(loginData),
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Login successful:", data);
        navigate("/admincontrol");
      } else {
        const errorText = await response.text();
        setErrorMessage(errorText || "Invalid credentials. For local dev, use: admin@local.dev / admin123");
      }
    } catch (error) {
      console.error("Error logging in:", error);
      setErrorMessage("Backend error. For local dev, use: admin@local.dev / admin123");
    }
  };

  return (
    <>
      <div className="AdminLogin-container">
        <div className="AdminLogin-box">
          <h3>Admin Login</h3>
          <form onSubmit={handlesubmit}>
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label htmlFor="password">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div className="checkbox-container">
              <input
                type="checkbox"
                checked={ischecked}
                onChange={(e) => {
                  setIsChecked(e.target.checked);
                }}
              />
              <label htmlFor="checkbox">Remember me</label>
            </div>
            <button type="submit">Login</button>
          </form>
          {errorMessage && <p className="error-message">{errorMessage}</p>}{" "}
        </div>
      </div>
    </>
  );
}

export default AdminLogin;
